import { lazy } from "react";

export const XpayApiShow = lazy(() => import("./xpayApiShow"));
export const XpaySdkShow = lazy(() => import("./xpaySdKShow"));
export const XpayApiEdit = lazy(() => import("./xpayApiEdit"));
export const XpaySdkEdit = lazy(() => import("./xpaySdKEdit"));
export const XpayDocShare = lazy(() => import("./xpayDocShare"));
